import React from "react";
import styled from "styled-components";

import HomeLayout from "./home";
import MainLayout from "./main";
import MainLayout2 from "./main2";
import RoomLayout from "./room";

export { HomeLayout, MainLayout, RoomLayout, MainLayout2 };
